module.exports = __webpack_public_path__ + "img/ff02d.45478f49.svg";